export default __webpack_public_path__ + "static/media/Montiel.fac67c1d.jpg";